import React, { useState } from 'react';
import { apiClient } from '../../App';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';
import { toast } from 'sonner';

const NewExpenseForm = ({ onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    category: 'supplies',
    item_name: '',
    amount: '',
    notes: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!form.category || !form.item_name || !form.amount) {
      toast.error('Category, item name, and amount are required');
      return;
    }

    setLoading(true);
    try {
      await apiClient.post('/expenses', {
        ...form,
        amount: parseFloat(form.amount)
      });
      toast.success('Expense recorded');
      onSuccess?.();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to record expense');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <Label>Category *</Label>
        <Select value={form.category} onValueChange={(v) => setForm({ ...form, category: v })}>
          <SelectTrigger data-testid="expense-category-select">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="supplies">Supplies</SelectItem>
            <SelectItem value="utilities">Utilities</SelectItem>
            <SelectItem value="rent">Rent</SelectItem>
            <SelectItem value="misc">Miscellaneous</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div>
        <Label>Item Name *</Label>
        <Input
          value={form.item_name}
          onChange={(e) => setForm({ ...form, item_name: e.target.value })}
          placeholder="e.g., Bandages, Electric bill"
          data-testid="expense-item-input"
        />
      </div>

      <div>
        <Label>Amount (PHP) *</Label>
        <Input
          type="number"
          value={form.amount}
          onChange={(e) => setForm({ ...form, amount: e.target.value })}
          placeholder="0.00"
          data-testid="expense-amount-input"
        />
      </div>

      <div>
        <Label>Notes</Label>
        <Textarea
          value={form.notes}
          onChange={(e) => setForm({ ...form, notes: e.target.value })}
          placeholder="Any additional notes..."
          rows={2}
        />
      </div>

      <div className="flex justify-end gap-2 pt-4">
        <Button type="submit" disabled={loading} data-testid="submit-expense-btn">
          {loading ? 'Saving...' : 'Log Expense'}
        </Button>
      </div>
    </form>
  );
};

export default NewExpenseForm;
